import React from 'react'
import { Grid, Button, PageSection as Section } from '@superhi/design'
import { useQuery } from '@apollo/client'
import uniqBy from 'lodash.uniqby'

import { API } from '../../../api'
import CourseCollectionCard from '../../CourseCollectionCard'
import { buildPath } from '../../../routing'

import { COURSE_COLLECTIONS } from './queries'

const COLLECTIONS_PATH = buildPath('collections-index')
const CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: 6,
}

type Props = {
  productCourseSlug?: string
  imagesLazy?: boolean
}

const CourseCollections: React.FC<Props> = ({ productCourseSlug, imagesLazy = false }) => {
  const { data } = useQuery<API.CourseCollectionsSection, API.CourseCollectionsSectionVariables>(
    COURSE_COLLECTIONS,
    {
      variables: {
        productCourseSlug,
      },
      ssr: false,
    },
  )
  const { data: dataExtra } = useQuery<API.CourseCollectionsSectionExtra>(COURSE_COLLECTIONS, {
    ssr: false,
  })

  const collections = React.useMemo(() => {
    const collections1 = data?.productCollections?.nodes || []
    const collections2 = dataExtra?.productCollections?.nodes || []
    return uniqBy([...collections1, ...collections2], 'id').slice(0, 2)
  }, [data?.productCollections?.nodes, dataExtra?.productCollections?.nodes])

  return (
    <Section
      title="Better together"
      subtitle="Reach your goals faster with our curated learning paths. Choose one of ours or make your own combination by choosing two or more courses. Either way, you’ll get a discount."
      footer={<Button href={COLLECTIONS_PATH}>View all learning paths</Button>}
      backgroundColor="pink"
    >
      <Grid alignItems="stretch">
        {collections.map((collection) => (
          <Grid.Cell key={collection.id} span={CELL_SPAN_1}>
            <CourseCollectionCard {...(collection as any)} imageLazy={imagesLazy} />
          </Grid.Cell>
        ))}
      </Grid>
    </Section>
  )
}

export default CourseCollections
